export default __webpack_public_path__ + "static/textlist_home_3_img_10-30510830a4f63e37bdc3b68f849beab6.png";